export default "__VITE_ASSET__CZj8Mol3__"